
define('tpl!taoQtiTest/runner/plugins/controls/timer/timers', ['handlebars'], function(hb){ 
return hb.template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", helper, options, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression;


  buffer += "<div class=\"timer-box\">\n    <a href=\"#\" class=\"timer-toggler hidden\" title=\""
    + escapeExpression((helper = helpers.__ || (depth0 && depth0.__),options={hash:{},data:data},helper ? helper.call(depth0, "Hide timers", options) : helperMissing.call(depth0, "__", "Hide timers", options)))
    + "\"><span class=\"icon-clock\"></span></a>\n    <div class=\"timer-wrapper\"></div>\n</div>\n";
  return buffer;
  });
});

